import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=3d358992&scoped=true"
import script from "./logistics.ts?vue&type=script&lang=ts&external"
export * from "./logistics.ts?vue&type=script&lang=ts&external"
import style0 from "./logistics.scoped.scss?vue&type=style&index=0&id=3d358992&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d358992",
  null
  
)

export default component.exports